<p-toast></p-toast>
<div class="siteUnderMaintenance" *ngIf="isSiteUnderMaintenance">
    <div class="logo">
        <img src="assets/activitiesImages/micada_new_logo.png" alt="Logo">
    </div>
    <h1>{{ 'SITE_UNDER_MAINTENANCE' | translate }}</h1>
    <p>{{ 'SITE_UNDER_MAINTENANCE_MSG1' | translate }}</p>

    <div class="button-row">
        <button class="goback-button p-3 text-sm mx-5" pButton pRipple label="{{'GO_BACK'| translate}}"
            (click)="goBack()"></button>
        <button class="reload-button p-3 text-sm mx-5" pButton pRipple label="{{'RELOAD_PAGE'| translate}}"
            (click)="reloadPage()"></button>
    </div>

</div>


<div class="marquee-text" style="flex: 1; overflow: hidden;">
    <marquee direction="left" onmouseover="this.stop();" onmouseout="this.start();" scrollamount="4">
        <span class="s1">{{ '! सावधान रहें और आधार ओटीपी को किसी के साथ साझा न करें|' }}</span> &nbsp;&nbsp;&nbsp;&nbsp;
    </marquee>
</div>
<div *ngIf="!isSiteUnderMaintenance"
    class="surface-0 flex align-items-center aadhar-login-bg justify-content-center min-h-screen min-w-screen overflow-hidden">
    <!-- <div class="aadhar-login-overlay"></div> -->
    <div class="grid justify-content-end p-2 lg:p-0 aadhar-login-content" style="min-width:100%">
        <div class="col-12 xl:col-6 lg:col-8 md:col-10 sm:col-12"
            style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, #2F9688 10%, rgba(33, 150, 243, 0) 100%);">
            <div class="h-full w-full m-0 py-3 px-4"
                style="border-radius:53px; background: linear-gradient(180deg, var(--surface-50) 38.9%, var(--surface-0));">
                <div class="text-center mb-5">
                    <img src="assets/activitiesImages/micada_new_logo.png" alt="Image" height="140" class="mb-3">

                    <div class="welcome-text">{{'WELCOME'| translate}}</div>
                    <div class="header-text">Farmer Aadhar Based Login
                    </div>
                    <span class="text-600 font-medium">{{'SIGN_IN_TO_CONTINUE'| translate}}</span>
                </div>
                <form [formGroup]="onAuthForm">
                    <div class="w-full md:w-10 mx-auto">
                        <div *ngIf="!(isOTPSend && display)">
                            <label for="aadhar" class="input-field-label">Aadhar Number</label>
                            <div class="aadhar-input-wrapper mb-3" style="position: relative;">
                                <input id="aadhar" type="{{ showAadhar ? 'text' : 'password' }}" maxlength="12"
                                    minlength="12" pattern="^[0-9]{12}$" pKeyFilter="int"
                                    placeholder="Enter Aadhar Number" pInputText class="w-full mb-3"
                                    style="padding:1rem; padding-right:3rem;" formControlName="aadhar"
                                    [readonly]="isOTPSend"
                                    [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.aadhar.errors }" />
                                <button type="button" pButton icon="pi pi-eye" class="aadhar-eye-btn"
                                    (mousedown)="showAadhar = true" (mouseup)="showAadhar = false"
                                    (mouseleave)="showAadhar = false" tabindex="-1" aria-label="Show Aadhar"></button>
                            </div>
                            <div *ngIf="submitted && f.aadhar.errors" class="invalid-feedback">
                                <div *ngIf="f.aadhar.errors.required">Aadhar number is required</div>
                                <div *ngIf="f.aadhar.errors.pattern">Enter a valid 12 digit Aadhar number</div>
                            </div>
                        </div>

                        <div *ngIf="isOTPSend && display"
                            class="timer-view">
                            <!-- <h4 *ngIf="!(display == null || display == '00:00')">{{ f.aadhar.value}}</h4> -->
                            <p class="otpsent">
                                {{'OTP sent on Registered Mobile No'| translate}}
                            </p>
                            <p class="request-otp-again">
                                <span *ngIf="isOTPSend && display">{{'YOU_CAN_REQUEST_OTP_IN'| translate}} {{display}}
                                    {{'MINUTES'| translate}}</span>
                            </p>
                        </div>

                        <div style="display: flex; justify-content: flex-end">
                            <button pButton label="Get OTP" class="p-button-outlined p-button-secondary mr-2 mb-2"
                                [disabled]="f.aadhar.invalid || isOTPSend" (click)="onOTPClick()"
                                [ngStyle]="{ 'background-color': themeColor, 'color': '#fff', 'border': 'none' }"></button>
                            <!-- <span *ngIf="isOTPSend && display">{{'YOU_CAN_REQUEST_OTP_IN'| translate}} {{display}}
                                {{'MINUTES'| translate}}</span> -->
                        </div>

                        <div *ngIf="isOTPSend && display">
                        <!-- <div> -->
                            <label for="otp" class="input-field-label mb-2 mt-3">Enter OTP</label>
                            <div class="otp-boxes">
                            <input *ngFor="let box of otpBoxes; let i = index"
                                type="text"
                                maxlength="1"
                                pattern="[0-9]*"
                                inputmode="numeric"
                                class="otp-input"
                                [id]="'otp'+i"
                                [disabled]="!isOTPSend"
                                [readonly]="!isOTPSend"
                                [(ngModel)]="otpBoxValues[i]"
                                (input)="onOtpInput($event, i)"
                                (keydown)="onOtpKeyDown($event, i)"
                                autocomplete="one-time-code"
                                [ngModelOptions]="{standalone: true}"
                            />
                            </div>
                            <div *ngIf="submitted && otpBoxError" class="invalid-feedback">
                            <div>Enter a valid 6 digit OTP</div>
                            </div>
                            <!-- <label for="otp" class="block text-900 font-medium text-xl mb-2 mt-3">Enter OTP</label>
                            <input id="otp" type="text" pattern="^[0-9]{6}$" minlength="6" maxlength="6"
                                pKeyFilter="int" placeholder="OTP" pInputText class="w-full mb-3" style="padding:1rem;"
                                formControlName="otp" [readonly]="!isOTPSend"
                                [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.otp.errors }"
                                [disabled]="!isOTPSend" />
                            <div *ngIf="submitted && f.otp.errors" class="invalid-feedback">
                                <div *ngIf="f.otp.errors.required">OTP is required</div>
                                <div *ngIf="f.otp.errors.pattern">Enter a valid 6 digit OTP</div>
                            </div> -->

                            <div class="p-fluid p-formgrid justify-content-center captcha-container {{ config.cssClass }}"
                                style="display: flex; flex-wrap:wrap">
                                <div class="field md:col-8 col-12 recaptcha-input recaptcha-input d-flex justify-content-center">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <canvas id="captcahCanvas" class="canvas" height="80"></canvas>
                                        <a class="cpt-btn" (click)="reloadCaptcha()">&#x21bb;</a>
                                    </div>
                                    <div class="captcha-actions my-1 d-flex justify-content-center">
                                        <input pInputText type="text" class="captache" [(ngModel)]="captch_input"
                                            name="captcha" [ngModelOptions]="{standalone: true}"
                                            placeholder="{{'Enter the CAPTCHA' | translate}}" (input)="checkCaptcha()" />
                                    </div>
                                </div>
                            </div>
                            <button pButton label="Sign In" class="sign-in-button w-full p-3 text-xl"
                                [disabled]="f.otp.invalid || !checkCaptchaValue" (click)="login()"
                                [ngStyle]="{ 'background-color': themeColor, 'color': '#fff', 'border': 'none' }"></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>